type AppEnv = {
  appEnv: string;
  apiBaseUrl: string;
  appPublicOrigin: string;
  lineMiniAppLiffId: string;
  legalPrivacyUrl: string | null;
  legalTermsUrl: string | null;
  enableMock: boolean;
  reviewDebugEnabled: boolean;
};

export function isProductionAppEnv(appEnv: string): boolean {
  return ["production", "prod"].includes(appEnv.toLowerCase());
}

export function resolveReviewDebugEnabled(appEnv: string, reviewDebugEnabled: boolean): boolean {
  return reviewDebugEnabled && !isProductionAppEnv(appEnv);
}

function parseOptionalHttpsUrl(value: string | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) {
    return null;
  }

  try {
    const url = new URL(trimmed);
    return url.protocol === "https:" ? url.toString() : null;
  } catch {
    return null;
  }
}

export function getEnv(): AppEnv {
  const appEnv = import.meta.env.VITE_APP_ENV ?? "development";

  return {
    appEnv,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8080",
    appPublicOrigin: import.meta.env.VITE_APP_PUBLIC_ORIGIN ?? "",
    lineMiniAppLiffId: import.meta.env.VITE_LINE_MINIAPP_LIFF_ID ?? "",
    legalPrivacyUrl: parseOptionalHttpsUrl(import.meta.env.VITE_LEGAL_PRIVACY_URL),
    legalTermsUrl: parseOptionalHttpsUrl(import.meta.env.VITE_LEGAL_TERMS_URL),
    enableMock: (import.meta.env.VITE_ENABLE_MOCK ?? "false") === "true",
    reviewDebugEnabled: resolveReviewDebugEnabled(
      appEnv,
      (import.meta.env.VITE_REVIEW_DEBUG_ENABLED ?? "false") === "true"
    )
  };
}
